import { render } from "./ReservationFilter.vue?vue&type=template&id=708539c0&scoped=true"
import script from "./ReservationFilter.vue?vue&type=script&lang=js"
export * from "./ReservationFilter.vue?vue&type=script&lang=js"

import "./ReservationFilter.vue?vue&type=style&index=0&id=708539c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708539c0"]])

export default __exports__